import axios from "axios";
import { STRINGS_ENV } from "../config/stringsEnv";
import { normalizeRusticMediaProduct } from "../utils/mediaUrl";

const API_URL = `${STRINGS_ENV.apiUrl}product`;

const productService = {
  getProductsPaginated: async (
    categories = [],
    priceOrder = "asc",
    limit = 10,
    page = 1,
    namePrefix = "",
    skuPrefix = ""
  ) => {
    const params = {
      priceOrder,
      limit,
      page,
      categories: categories.join(","),
      namePrefix,
      skuPrefix,
    };

    const res = await axios.get(`${API_URL}/all`, { params });
    return res.data;
  },

  getProduct: async (sku) => {
    const res = await axios.get(`${API_URL}/sku`, { params: { sku } });
    return normalizeRusticMediaProduct(res.data);
  },

   getCategories: async () => {
    const res = await axios.get(`${API_URL}/categories`);
    return res.data;
  },
};

export default productService;
